import { render, staticRenderFns } from "./OrderDispatchNew.vue?vue&type=template&id=04564f3c&"
import script from "./OrderDispatchNew.vue?vue&type=script&lang=js&"
export * from "./OrderDispatchNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports